import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output, SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'frontend-dropdown-list',
  templateUrl: './frontend-dropdown-list.component.html',
  styleUrls: ['./frontend-dropdown-list.component.scss'],
  standalone: false,
})
export class FrontDropdownListComponent<T extends Record<string, any>> implements OnChanges, AfterViewInit {
  @ViewChild('modalContent') modalContentRef?: ElementRef;
  @ViewChild('listContent') listContent?: ElementRef;
  @Output() displayItemsChange = new EventEmitter<T[]>();
  @Output() listContentInit = new EventEmitter<ElementRef>();

  @Input() showAddTagOnlyIfNoResults = false;
  @Input() maxSelectedItems?: number;
  @Input() noItemsText = 'No items';
  @Input() items: T[] = [];
  @Input() searchString = '';
  @Input() addTag = false;
  @Input() minWidth = '6rem';
  @Input() maxListHeight = '11rem';
  @Input() multiple = false;
  @Input() disabled = false;
  @Input() bindLabel = '';
  @Input() bindValue = '';
  @Input() plainValues = false;

  @Input() itemsIdToLabelMap: Record<string, string> = {};
  @Input() itemsIdToStateMap: Record<string, boolean> = {};
  @Input() selectSingleItem!: (itemId: string) => void;
  @Input() checkboxChange!: (id: string, eventDetail: any) => void;
  @Input() addNewItem!: () => void;
  @Input() value: string[] = [];
  @Input() searchFieldValue?: any;
  @Input() inverted = false;
  @Input() showBorder = true;

  constructor(private readonly cdr: ChangeDetectorRef) { }

  displayItems: T[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['items'] && this.items && Object.keys(this.items).length)) {
      this.filterDisplayItems();
    }

    if (changes['searchString']) {
      this.filterDisplayItems();
    }
  }

  filterDisplayItems(): void {
    if (!this.multiple && this.value.length > 0) {
      this.searchString = '';
    }

    this.displayItems = this.items.filter((item) => {
      const label = this.itemsIdToLabelMap[String(item[this.bindValue])];
      if (!label) {
        return false;
      }

      return label.toLowerCase().includes(this.searchString.toLowerCase());
    });
    this.displayItemsChange.emit(this.displayItems);

    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    if (!this.listContent) {
      return;
    }

    this.listContentInit.next(this.listContent);
  }

  protected readonly icon = AppIcon;
  protected readonly size = AppIconSize;
  protected readonly iconColor = AppIconColor;
}
